import { InputField } from '@eventbrite/eds-input-field';
import React from 'react';

const VerificationField = ({
    field,
    shouldFocus,
    elementNumber,
    onChange,
    onPaste,
    disabled,
    onInvalidValue,
}: {
    field: any;
    shouldFocus: boolean;
    elementNumber: number;
    onChange: (value: number) => void;
    onPaste: () => void;
    onInvalidValue: () => void;
    disabled: boolean;
}) => {
    /* This section simulates an onChange with formik which overrides and
     * blocks the `onChange` as a prop to the component
     */
    const [lastValue, setLastValue] = React.useState<string>('');

    React.useEffect(() => {
        const isNumericValue = /[0-9]/i.test(field.value) || !field.value;
        if (lastValue !== field.value && isNumericValue) {
            const newSelectedField = field.value
                ? elementNumber + 1
                : elementNumber - 1;
            onChange?.(newSelectedField);

            setLastValue(field.value);
        } else {
            if (field.value) {
                setLastValue('');
                onInvalidValue();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field.value]);
    /* This section simulates an onChange with formik which overrides and
     * blocks the `onChange` as a prop to the component
     */

    return (
        <InputField
            id={field.name}
            name={field.name}
            type="tel"
            pattern="[0-9]+"
            field={field}
            required={true}
            style="basic"
            bottomSpacing={2}
            maxLength={1}
            label="-"
            placeholder="-"
            shouldFocus={shouldFocus}
            onFocus={() => {
                ('this.select();');
            }}
            onPaste={onPaste}
            disabled={disabled}
        />
    );
};

export default VerificationField;
